let token    = window.localStorage.getItem('user-token')
let user     = window.localStorage.getItem('user')
let customer = window.localStorage.getItem('customer')
if (user === undefined || user === 'undefined') {
  window.localStorage.removeItem('customer')
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('user-token')
  user     = false
  token    = undefined
  customer = false
}

import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, SET_CUSTOMER, AUTH_RESET_PSWD, AUTH_CHECK_TOKEN, AUTH_CHANGE_PSWD } from '../actions/auth'
import { RESET_TMP_CART, SAVE_CART, RESET_CART_ITEMS, RESET_OLD_CART } from '../actions/cart'
import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const UsersRepository = RepositoryFactory.get('users')
import { SET_SNACK } from '@/store/actions/snackbar'
import axios from 'axios'

const state = {
  token: token || '',
  status: '', 
  hasLoadedOnce: false,
  user: user ? JSON.parse(user) : {},
  customer: customer ? JSON.parse(customer) : {},
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  displayUserName: state => `${state.user.firstName.charAt(0)}. ${state.user.lastName}`,
  isAdmin: state => (!!state.token && state.user.role.code === 'EXPONENT'),
  hasCustomer: state => state.customer.hasOwnProperty('apiToken'),
  getCustomer: state => state.customer,
  getAuthToken: state => state.token,
  needsToRelog: state => !Object.prototype.hasOwnProperty.call(state.user, 'discount'),
  getDiscount(state, getters) {
    if (getters.isAdmin && getters.hasCustomer) {
      if (state.customer.discount !== null) {
        return parseFloat(state.customer.discount)
      }
    } else {
      if (state.user.discount !== null) {
        return parseFloat(state.user.discount)
      }
    }
    
    return null
  }
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise(async (resolve, reject) => {
      UsersRepository.login(user)
        .then(({ data }) => {
          window.localStorage.setItem('user-token', data.token)
          axios.defaults.headers.common['X-Custom-Auth'] = data.token
          commit(AUTH_SUCCESS, data)
          dispatch(AUTH_SUCCESS, data)
          commit(SET_SNACK, {
            message: 'Connecté',
            color: 'success',
          })
          resolve(data)
        }).catch(err => {
          commit(AUTH_ERROR, err)
          window.localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT)
      window.localStorage.removeItem('customer')
      window.localStorage.removeItem('user')
      window.localStorage.removeItem('user-token')
      commit(SET_SNACK, {
        message: 'Déconnecté',
        color: 'success',
      })
      resolve()
    })
  },
  [AUTH_RESET_PSWD]: ({ commit }, email) => {
    return new Promise((resolve, reject) => {
      UsersRepository.resetPassword(email)
        .then(({ data }) => {
          commit(SET_SNACK, {
            message: 'Lien envoyé par mail',
            color: 'success',
          })
          resolve(data)
        })
        .catch(error => {
          commit(SET_SNACK, {
            message: 'Une erreur est survenue lors de l\'envoi',
            color: 'error',
          })
          reject(error)
        })
    })
  },
  [AUTH_CHECK_TOKEN]: (context, token) => {
    return new Promise((resolve, reject) => {
      UsersRepository.checkResetPasswordToken(token)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [AUTH_CHANGE_PSWD]: ({ commit }, { token, password }) => {
    return new Promise((resolve, reject) => {
      UsersRepository.changePassword({ token, password })
        .then(({ data }) => {
          commit(SET_SNACK, {
            message: 'Mot de passe modifié',
            color: 'success',
          })
          resolve(data)
        })
        .catch(error => {
          commit(SET_SNACK, {
            message: 'Une erreur est survenue',
            color: 'error',
          })
          reject(error)
        })
    })
  },
  [SET_CUSTOMER]: ({ commit }, customer) => {
    return new Promise((res, rej) => {
      commit(SET_CUSTOMER, customer)
      commit(RESET_CART_ITEMS)
      commit(RESET_OLD_CART)
      commit(RESET_TMP_CART)
      commit(SAVE_CART)
      commit(SET_SNACK, {
        message: 'Client sélectionné',
        color: 'success',
      })
      res()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.token
    state.user  = resp.infos
    window.localStorage.setItem('user', JSON.stringify(state.user))
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: state => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: state => {
    state.token = ''
    state.user = {}
    state.customer = {}
  },
  [SET_CUSTOMER]: (state, customer) => {
    state.customer = customer
    window.localStorage.setItem('customer', JSON.stringify(customer))
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};